/**
 * @fileoverview Language selection modal.
 * Allows the user to choose a different language, which is then saved
 * to local storage and reloaded.
 */

import { render } from 'preact';
import { tapProps } from '../utilities/tapProps.js';
import { setLang, supportedLangs } from '../i18n/lang.js';

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

function LanguageModal() {
    const selectLang = (lang: string) => {
        setLang(lang);
        window.location.reload();
    };

    return (
        <div id="languageModal" class="modal-overlay" {...tapProps(hideLanguageModal)}>
            <div class="modal-content" onClick={e => e.stopPropagation()} onTouchEnd={e => e.stopPropagation()}>
                <h2>Change Language</h2>
                <div class="language-list">
                    {Object.entries(supportedLangs).map(([code, name]) => (
                        <button
                            class="language-item menu-item"
                            {...tapProps(() => selectLang(code))}
                        >
                            {name}
                        </button>
                    ))}
                </div>
                <button class="modal-close" {...tapProps(hideLanguageModal)}>
                    &times;
                </button>
            </div>
        </div>
    );
}

// ---------------------------------------------------------------------------
// Mount/unmount helpers
// ---------------------------------------------------------------------------

function mount(): void {
    let container = document.getElementById('modalContainer');
    if (!container) {
        container = document.createElement('div');
        container.id = 'modalContainer';
        document.body.appendChild(container);
    }
    render(<LanguageModal />, container);
    // Show modal with a fade-in effect
    setTimeout(() => {
        const modal = document.getElementById('languageModal');
        if (modal) {
            modal.classList.add('visible');
        }
    }, 10);
}

/** Unmounts the component and removes the container. */
function unmount(): void {
    const container = document.getElementById('modalContainer');
    if (container) {
        // Hide modal with a fade-out effect
        const modal = document.getElementById('languageModal');
        if (modal) {
            modal.classList.remove('visible');
        }
        // Wait for animation to finish before removing
        setTimeout(() => {
            render(null, container);
            container.remove();
        }, 300);
    }
}

export function showLanguageModal(): void {
    mount();
}

export function hideLanguageModal(): void {
    unmount();
}
